import React from 'react';
import { withRouter } from 'react-router-dom';
import Gears from '../assets/Gears.svg';
import QbeLogo from '../assets/QBE_Logo_Complete.jpg';
import { useCookies } from 'react-cookie';

const RedirectPage = (props) => {
    const [cookies, setCookie, removeCookie] = useCookies(['sme']);

    console.log('pathname = ' + props.location.pathname);
    const site = props.location.pathname.substring(1);
    if (site === 'clear') {
        removeCookie('site');
    }
    else {
        setCookie('site', site);
        console.log("path = " + site);
    }
    props.history.push(window.location.path);
    return (
        <>
            <div id="splash-screen">
                <div id="gears-box">
                    <img src={Gears} height="160" />
                </div>
                <div id="logo-box">
                    <img src={QbeLogo} height="90" />
                </div>
            </div>
        </>
    );
}

export default withRouter(RedirectPage);
